<template>
    <div class="con">
        <div class="main">
            <div class="nav">
                <span @click="goto(0)">{{$t('proInfo2').text1}} /</span>
                <span @click="goto(1)">{{$t('proInfo2').text2}} /</span>
                <span @click="goto(2)">{{text}} /</span>
                <span>{{info.proarr.PRONAME}} {{info.proarr.TITLE2}}</span>
            </div>
      <div class="left">
          <p>{{info.proarr.PRONAME}}</p>
     <div class="bigImg">
         <viewer :images="bigList" >
             <img v-for="item in bigList" :src="item.url" :key="item.index">
         </viewer>

     </div>
          <div class="sImg">
              <div class="item" v-for="(item,index) in info.proimg" :key="index">
                  <img :src="`http://www.yourlonglighting.com/upload/${item.PICURL}`" alt="" @click="changeImg(item.PICURL)">
              </div>
          </div>
      </div>
<!--            <div class="right">-->
<!--                <p class="name">{{info.proarr.PRONAME}}</p>-->
<!--                <div class="content"  v-html="info.proarr.CONTENT">-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="html">
<!--            <p class="title">{{$t('proInfo')}}</p>-->
<!--            <div class="navList">-->
<!--            <span v-for="(item,index) in $t('proInfo2').navList" :key="index" :class="{'showNav':select===index}" @click="change(index)">{{item}}</span>-->
<!--            </div>-->
            <div class="htmlCon"  v-html="info.proarr.CONTENT[0]">

            </div>
<!--            <transition name="fade">-->
<!--           -->
<!--            </transition>-->
<!--            <transition name="fade">-->
<!--                <div class="htmlCon" v-if="select===1" v-html="info.proarr.CONTENT[1]">-->

<!--                </div>-->
<!--            </transition>-->
<!--            <transition name="fade">-->
<!--                <div class="htmlCon" v-if="select===2" v-html="info.proarr.CONTENT[2]">-->

<!--                </div>-->
<!--            </transition>-->
        </div>
        <div class="commend">
            <p class="name">{{$t('proInfo2').text3}}</p>
            <div class="allItems">
                <div class="oneItem" v-for="(item,index) in proList" :key="index">
                    <router-link :to="{path: 'proInfo',query:{id:item.ID,tid:tid}}" target="_blank">
                        <img :src="`http://www.yourlonglighting.com/upload/${item.SMALLPIC}`" alt="">
                        <p class="t1">{{item.PRONAME}}</p>
                        <div class="last">
                            <p>{{item.TITLE2}}</p>
                            <i class="iconfont icon-youjiantou"></i>
                        </div>
                    </router-link>
                </div>
            </div>

        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import {getProductsInfo,getProductstypeUrl2,getProductsUrl} from '../util/lang'
    export default {
        name: "proInfo",
        data(){
            return{
                proList:[],
                select:0,
                tid:'',
                navList:[
                    "specification",
                    "feature",
                    "certification"
                ],
                text:'',
                bigList:[{url:'http://www.yourlonglighting.com/upload/'}],
                info:{
                    proarr:{
                        CONTENT:[]
                    },
                    proimg:{}
                }
            }
        },
        components:{footComponent},
        mounted(){
            if(this.$i18n.locale==='en'){
                this.getPro('72')
            }else{
                this.getPro('84')
            }
            this.$nextTick(()=>{
                this.getInfo(this.$route.query.id)
                this.tid=this.$route.query.tid
                this.getProducts(this.$route.query.tid)
            })
        },
        methods:{
            getProducts(id){
                const url = `${getProductsUrl(this.$i18n.locale,id,10000,1)}`
                this.$axios.get(url).then(res => {
                    res.data.proarr.map((item)=>{
                        if(item.ISCOMMEND==='1'){
                            this.proList.push(item)
                        }
                    })
                })
            },
            change(n){
                this.select=n
            },
            goto(n){
               if(n===0){
                   this.$router.push({path:'/'})
               }else if(n===1){
                   this.$router.push({path:'/pro'})
               }else{
                   this.$router.push({path:'/proList',query:{id:this.$route.query.tid}})
               }
            },
            getPro(id){
                this.$nextTick(()=>{
                    const url = `${getProductstypeUrl2(this.$i18n.locale,id)}`
                    this.$axios.get(url).then(res => {
                        res.data.map((item)=>{
                            if(item.ID===this.$route.query.tid){
                                this.text=item.CALLED
                            }
                        })
                    })
                })
            },
            changeImg(n){
                this.bigList[0].url='http://www.yourlonglighting.com/upload/'+n
            },
            getInfo(id){
                const url = `${getProductsInfo(this.$i18n.locale,id)}`
                this.$axios.get(url).then(res => {
                    res.data.proarr.CONTENT=res.data.proarr.CONTENT.split('{nextpage}')
                    this.info=res.data
                        this.bigList[0].url= this.bigList[0].url+res.data.proimg[0].PICURL
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    background-color: #F4F4F4;
    padding-top: 100px;
    animation: down 2s linear;
    @keyframes down {
        from{
            transform: translateX(-30px);
        }
        to{
            transform: translateX(0);
        }
    }
    .main{
        width:1280px;
        margin: 60px auto;
        display: flex;
        flex-direction: column;
        .nav{
            width:100%;
            margin: 30px 0;
            span{
                text-transform: uppercase;
                padding-right: 5px;
                cursor: pointer;
                font-family: Calibri;
            }
            span:last-child{
                color:#F4A000;
            }
        }
        .left{
            display: flex;
            flex-direction: column;
            align-items: center;
            width:100%;
            p{
                font-size: 30px;
                text-align: center;
            }
            .sImg{
                width:100%;
                display: flex;
                flex-direction: row;
                margin-top: 10px;
               justify-content: center;
                .item{
                    cursor: pointer;
                    margin-left: 2%;
                    img{
                        width:70px;
                        object-fit: cover;
                        padding: 10px 15px;
                    }
                }
            }
            .bigImg{
                margin-left: 2%;
                cursor: pointer;
                img{
                    display: block;
                }
            }
        }
        /*.right{*/
        /*    margin-left: 5%;*/
        /*    .name{*/
        /*        font-family: 'dine';*/
        /*        font-size: 40px;*/
        /*        text-transform: uppercase;*/
        /*        margin: 0;*/
        /*        margin-block-end: 0.5em;*/
        /*    }*/
        /*    .content{*/
        /*        font-family: "Fira Code Light";*/
        /*        font-weight: lighter;*/
        /*        line-height: 30px;*/
        /*        text-transform: capitalize;*/
        /*    }*/
        /*}*/
    }
    .html{
        width:1280px;
        margin:60px auto;
        .title{
            text-align: center;
            font-family:Calibri;
            font-size: 30px;
            padding-bottom: 30px;
            border-bottom: 1px solid rgba(0,0,0,.1);
        }
        .navList{
          width:100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            span{
                display: inline-block;
                text-align: center;
                padding: 15px 60px;
                background-color: #ececec;
                text-transform: capitalize;
                cursor: pointer;
                transition: all 1s;
            }
            span:hover{
                background-color: #004097;
                color:white;
            }
            .showNav{
                background-color: #004097;
                color:white;
            }
        }
        .htmlCon{
            width:100%;
            line-height: 30px;
            font-family:Calibri;
            font-weight: lighter;
            font-size: 14px;
            margin: 0 auto;
        }
    }
    .commend{
        width:1280px;
        margin: 60px auto;
        .name{
            text-align: center;
            font-size: 30px;
            font-family: Calibri;
            text-transform: uppercase;
        }
        .allItems{
            width:100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .oneItem{
                width:22%;
                background-color: white;
                text-align: center;
                cursor: pointer;
                margin-left: 2%;
                margin-top: 50px;
                transition: all 1s;
                padding: 10px 0;
                a{
                    display: inline-block;
                    width:100%;
                }
                img{
                    width:100%;
                    height:250px;
                    object-fit: cover;
                }
                p{
                    text-align: left;
                    width:80%;
                    margin-left: 10%;
                    font-family:Calibri;
                    text-transform: uppercase;
                }
                .t1{
                    font-size: 22px;
                    margin-block-end: 0;
                    transition: all 2s;
                    display: -webkit-box;
                    height:30px;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                }
                .last{
                    width:80%;
                    margin-left: 10%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    i{
                        color:#696969;
                        font-size: 20px;
                        transition: all 2s;
                    }
                    p{
                        margin-block-start: 0.5em;
                        margin-left: 0;
                        color:#696969;
                    }
                }
            }
            .oneItem:hover{
                box-shadow:5px 5px 5px 5px #e2e2e2;
                .t1{
                    color:#F4A000;
                }
                .last{
                    i{
                        color:#F4A000;
                    }
                }
            }
        }
    }
    @media screen and (max-width:450px) {
        overflow: hidden;
        .banner {
            img {
                height: 300px;
            }
        }
         .main{
             width:95%;
             flex-direction: column;
             margin: 30px auto;
             .nav{
                 line-height: 30px;
             }
             .left{
                 height:400px;
                 width:100%;
                 .bigImg{
                     height:300px;
                     div{
                         height:100%;
                         width:100%;
                         img{
                             width:100%;
                             height:100%;
                             object-fit: cover;
                         }
                     }
                 }
             }
             .right{
                 width:98%;
                 margin-left: 2%;
                 .name{
                     font-size: 30px;
                 }
                 .content{
                     font-size: 14px;
                     width:100%;
                 }
             }
         }
        .html{
            width:95%;
            margin: 60px auto;
            .title{
                font-size: 20px;
            }
            .navList{
                span{
                    width:33%;
                    padding: 10px 0;
                }
            }
        }
        .commend{
            width:90%;
            .allItems{
                flex-direction: column;
                .oneItem{
                    width:100%;
                    margin-left: 0;
                    img{
                        height:auto;
                    }
                }
            }
        }
    }
}
</style>
<style scoped>
    .content >>> p img{
        width:100%;
        object-fit: cover;
    }
    .content >>> div img{
        width:100%;
        object-fit: cover;
    }
    @media screen and (max-width:450px){
        .content >>> p img{
            width:100%;
            object-fit: cover;
        }
        .content >>>  table{
            width:100%;
            word-break: break-all;
        }
        .html >>> p img{
            width:100%;
            object-fit: cover;
        }
        .html >>>  table{
            width:100%;
            word-break: break-all;
        }
    }

</style>
<style scoped>
    .content >>> p img{
        width:100%;
        object-fit: contain;
    }
    .content >>>  table{
        width:100%;
        word-break: break-all;
    }
    .html >>> p img{
        width:100%;
        object-fit: contain;
    }
    .html >>>  table{
        width:100%;
        word-break: break-all;
    }
</style>
